import React from 'react';
import {Responsive, WithPermission} from 'admin-on-rest';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {fuseSystemIcon as SystemIcon} from './System/system';
import {fuseSysOpIcon as SystemOpIcon} from './System/sysOp';
import {fuseSysAdminIcon as SystemAdminIcon} from './System/sysAdmin';
import FuseTheme from './global/theme';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import AddIcon from 'material-ui/svg-icons/content/add';
import ReportIcon from 'material-ui/svg-icons/editor/pie-chart';

const styles = {
    avatar: {backgroundColor: FuseTheme.palette.avatarColor, width: 40, height: 40},
    dash: {flex: {display: 'flex'}},
    dashContainer: {position: 'relative', marginRight: '1em'},
    dashTitle: {width: 'calc(100% - 180px)', boxSizing: 'border-box'},
    dashLogo: {position: 'absolute', top: '50%', right: 12, width: 180, height: 93, transform: 'translateY(-50%'},
    listCard: {width: 'calc(100% - 1em)', borderLeft: 'solid 4px' + FuseTheme.palette.primary1Color, flex: 1},
    listCardHalf: {
        flex: '0 1 50%',
        display: 'inline-block',
        width: 'calc(50% - 1em)',
        margin: '0 1em 0 0',
        verticalAlign: 'top'
    },
    listCardLast: {margin: '0'},
    logoImage: {width: '100%', height: 'auto'},
    marginBottom: {marginBottom: '2em'}
};

export default () => (
    <div>
        <Responsive
            small={
                <Card style={{...styles.dash, ...styles.marginBottom}}>
                    <ViewTitle title="Dashboard" style={styles.dashTitle}/>
                    <CardText style={styles.dashTitle}>
                        Welcome to CloudSent POS Reports.
                    </CardText>
                </Card>
            }
            medium={
                <Card style={{...styles.dash, ...styles.dashContainer, ...styles.marginBottom}}>
                    <div style={styles.dashLogo}>
                        <img src="CloudSent-POS-logo-admin.png" style={styles.logoImage} alt="CloudSent POS"/>
                    </div>
                    <ViewTitle title="Dashboard" style={styles.dashTitle}/>
                    <CardText style={styles.dashTitle}>
                        Welcome to CloudSent POS System Operations.
                    </CardText>
                </Card>
            }
        />

        <WithPermission value={['sys_op']}>

            {/* Systems */}
            <Card className="listCard" style={{...styles.listCard, ...styles.marginBottom}}>
                <CardHeader
                    title="Systems"
                    subtitle="Create, Manage, and view Reports for all Systems."
                    avatar={<Avatar icon={<SystemIcon/>} style={styles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Systems" href="#/Systems"/>
                    <FlatButton icon={<AddIcon/>} label="Add a System" href="#/Systems/create"/>
                    <FlatButton icon={<ReportIcon/>} label="View Systems Report" href="#/SystemsReport"/>
                </CardActions>
            </Card>

            {/* System Ops */}
            <Card className="listCard" style={{...styles.listCard, ...styles.marginBottom}}>
                <CardHeader
                    title="Sysops"
                    subtitle="Create and Manage all System Operators."
                    avatar={<Avatar icon={<SystemOpIcon/>} style={styles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Sysops" href="#/Sysops"/>
                    <FlatButton icon={<AddIcon/>} label="Add a Sysop" href="#/Sysops/create"/>
                </CardActions>
            </Card>

            {/* SysAdmins */}
            <Card className="listCard"
                  style={{...styles.listCard, ...styles.listCardHalf, ...styles.marginBottom}}>
                <CardHeader
                    title="Sysadmins"
                    subtitle="Create and Manage all System Administrators."
                    avatar={<Avatar icon={<SystemAdminIcon/>} style={styles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Sysadmins" href="#/Sysadmins"/>
                    <FlatButton icon={<AddIcon/>} label="Add a Sysadmin" href="#/Sysadmins/create"/>
                </CardActions>
            </Card>

            {/* System Users */}
            <Card className="listCard" style={{...styles.listCard, ...styles.listCardHalf, ...styles.listCardLast, ...styles.marginBottom}}>
                <CardHeader
                    title="Sysusers"
                    subtitle="Create and Manage all System Users."
                    avatar={<Avatar icon={<SystemAdminIcon/>} style={styles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Sysusers" href="#/Sysusers"/>
                    <FlatButton icon={<AddIcon/>} label="Add a Sysuser" href="#/Sysusers/create"/>
                </CardActions>
            </Card>

        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/dashboard.js